import { makeStyles } from '../../../state/hooks';

export default makeStyles()(theme => ({
    tableBodyCell: {
        paddingTop: 6,
        paddingBottom: 6,
    },
}));
